import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { PortfolioRouter } from './portfolio/Router';
import { CapitalProviderTemplate } from '~/capitalProvider/domains/page/ui/CapitalProviderTemplate';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

// Exports
export const CapitalProviderRouter = () => {
  return (
    <CapitalProviderTemplate>
      <Routes>
        <Route
          path="/portfolio/*"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <PortfolioRouter />
            </RouteErrorBoundary>
          }
        />

        <Route path="/*" element={<Navigate to="/portfolio" replace />} />
      </Routes>
    </CapitalProviderTemplate>
  );
};
